import { nodeViewDecorators } from 'ricos-common-plugins/viewer';
import { Decorators } from './nodeViewDecorators.js';

const decorators = nodeViewDecorators;

export { decorators, Decorators as default };
//# sourceMappingURL=index.js.map
